import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import Iframe from "react-iframe";
import P419PDF from "./P419PDF";
// const pdf2base64 = require("pdf-to-base64");

export default function P419Dialog({ dialog, setDialog }) {
    useEffect(() => {
        // fileToBase64();
    }, []);

    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button
                    label="ปิดหน้าต่าง"
                    icon="pi pi-times"
                    onClick={() => setDialog(false)}
                    className="p-button-info p-button"
                    // style={{width:150}}
                />
            </div>
        );
    };

    const onHide = () => {
        setDialog(false);
    };

    // const fileToBase64 = () => {
    //     pdf2base64("./PMS_GIS.pdf")
    //         .then((response) => {
    //             // console.log(response);
    //             // setBase64PDF("data:application/pdf;base64," + response);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // };
    // console.log(base64PDF);
    return (
        <>
            <Dialog header="ดาวน์โหลดคู่มือการบันทึกแนวเส้นท่อ GIS" visible={dialog} style={{ width: "80vw" }} className="p-fluid ___widthDialog" footer={renderFooter()} onHide={() => onHide()} blockScroll={true} maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 10, paddingTop: 50, textAlign: "center" }}>
                    <div className="p-col-12 ">
                        <label>
                            <h4>
                                <b>ดาวน์โหลดคู่มือการบันทึกแนวเส้นท่อ GIS </b>
                            </h4>
                        </label>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12 ">
                        <Iframe url={P419PDF.pdf} width="1000px" height="500px" display="initial" position="relative" />
                    </div>
                </div>
            </Dialog>
        </>
    );
}
